import type {
  PolicyApiResponse,
  PolicyDetailApiResponse,
} from '../../features/policies/policies.models';

/**
 * ポリシー一覧Mockデータ
 * APIの PolicyListResponse.items[] に対応
 */
export const MOCK_POLICIES: PolicyApiResponse[] = [
  {
    publicId: 'policy-001',
    name: 'テナント管理者ポリシー',
    description: 'テナント全体の管理権限を持つポリシー',
    isTenantAdmin: true,
    userCount: 2,
    createdAt: '2024-01-01T00:00:00.000Z',
  },
  {
    publicId: 'policy-002',
    name: '八幡チーム審査担当',
    description: '八幡事業所の審査データ編集権限',
    isTenantAdmin: false,
    userCount: 2,
    createdAt: '2024-01-15T00:00:00.000Z',
  },
  {
    publicId: 'policy-003',
    name: '東日本閲覧専用',
    description: '東日本製鉄所の審査データ閲覧権限',
    isTenantAdmin: false,
    userCount: 2,
    createdAt: '2024-02-01T00:00:00.000Z',
  },
  {
    publicId: 'policy-004',
    name: 'GX事務局担当',
    isTenantAdmin: false,
    userCount: 0,
    createdAt: '2024-03-01T00:00:00.000Z',
  },
];

/**
 * ポリシー詳細Mockデータ
 * permissions + users 付き
 */
export const MOCK_POLICY_DETAILS: PolicyDetailApiResponse[] = [
  {
    publicId: 'policy-001',
    name: 'テナント管理者ポリシー',
    description: 'テナント全体の管理権限を持つポリシー',
    isTenantAdmin: true,
    permissions: [
      { groupId: '*', groupName: 'すべてのグループ', access: 'writable' },
    ],
    users: [
      { publicId: 'user-001', name: '田中 一郎' },
      { publicId: 'user-006', name: '小林 雪' },
    ],
  },
  {
    publicId: 'policy-002',
    name: '八幡チーム審査担当',
    description: '八幡事業所の審査データ編集権限',
    isTenantAdmin: false,
    permissions: [
      { groupId: 'group-005', groupName: '八幡事業所', access: 'writable' },
    ],
    users: [
      { publicId: 'user-002', name: '佐藤 花子' },
      { publicId: 'user-003', name: '鈴木 太郎' },
    ],
  },
  {
    publicId: 'policy-003',
    name: '東日本閲覧専用',
    description: '東日本製鉄所の審査データ閲覧権限',
    isTenantAdmin: false,
    permissions: [
      { groupId: 'group-003', groupName: '東日本製鉄所', access: 'readonly' },
    ],
    users: [
      { publicId: 'user-003', name: '鈴木 太郎' },
      { publicId: 'user-005', name: '中村 涼' },
    ],
  },
  {
    publicId: 'policy-004',
    name: 'GX事務局担当',
    isTenantAdmin: false,
    permissions: [
      { groupId: 'group-010', groupName: 'GX事務局', access: 'writable' },
    ],
    users: [],
  },
];

/**
 * ポリシーIDからポリシー詳細データを取得
 */
export function findPolicyDetailById(
  policyId: string,
): PolicyDetailApiResponse | undefined {
  return MOCK_POLICY_DETAILS.find((p) => p.publicId === policyId);
}
